<!--
    FORMULARIO DE REGISTRO E CRIACAO DA CONTA


RECEBE PARAMSTROS DE QUAL APLICACAO FOI SELECIONADA E QUAL PLANO


-->




<template>

    <div class="registro">
            <header class="shared-header">
                        <div class="col-md-12 col-12 text-center">
                            <a class="valign" href="#">
                                <img src="https://s3.amazonaws.com/novo.notabrasil.com.br-bucket/imagens/logo/logo-nb.png">
                            </a>
                        </div>
            </header>

            <div v-if="estagio=='registro'">
                <div class="container">
                    <div>
                        <div class="row justify-content-center" style="padding: 40px">
                            <h2 class="title-principal">Experimente o Nota Brasil</h2>
                        </div>
                        <div class="row justify-content-center" style="padding-bottom: 40px">
                            <h6>Informe-nos alguns dados para efetuar o cadastro:</h6>
                        </div>

                        <div class="row justify-content-center">
                            <div class="box-registro">
                                <div class="row p-3">
                                    <form-field ref="email" v-model="registro.email" :metadata="metadata.registro.email" type="email" col="12"
                                        name="email_" :v-errors="errors" v-validate="{required: true, email: true}"></form-field>
                                    <form-field ref="nome" v-model="registro.nome" :metadata="metadata.registro.nome" type="text" col="12"
                                        name="nome" :v-errors="errors" v-validate="{required: true}"></form-field>
                                    <form-field v-model="registro.nomeempresa" :metadata="metadata.registro.nomeempresa" type="text" col="12"
                                        name="nomeempresa" :v-errors="errors" v-validate="{required: true}"></form-field>
                                    <form-field v-model="registro.telefone" :metadata="metadata.registro.telefone" type="fone" col="12"
                                        name="telefone" :v-errors="errors" v-validate="{required: true, numeric: true, min: 10, max: 11}" mask=""></form-field>
                                    <form-field v-model="registro.senha" :metadata="metadata.registro.senha" type="password" col="12"
                                        name="senha_" :v-errors="errors" v-validate="{required: true, min: 8}"></form-field>
                                    <!-- <form-field v-model="registro.tpempresa" type="select" col="12" :metadata="metadata.registro.tpempresa"
                                        name="tpempresa" :v-errors="errors" v-validate="{required: true}"></form-field> -->

                                    <div class="col-md-12 mb-3" style="text-align: center;">
                                        <div style="display: inline-block">
                                            <vue-recaptcha
                                              @verify="verifyRecaptcha"
                                              @expired="expiredRecaptcha"
                                              sitekey="6LfSaFwaAAAAAE7xHvOUv8oMzqBgigvpLYNnj2Od" :loadRecaptchaScript="true"></vue-recaptcha>
                                        </div>
                                    </div>

                                    <div class="col-md-12 mb-2">
                                        <span class="error"> {{ errmessages }} </span>
                                    </div>

                                    <div class="col-md-12">
                                        <button type="button" class="login-button" style="width: 100%" @click="handleRegistrar" :disabled="registrando"> {{ botaoRegistrar }} </button>
                                    </div>
                                    <div class="col-md-12 mb-2">
                                        <label class="lbl-edit">
                                            Clicando no botão acima você concorda com nossos <a href="http://notabrasil.com.br/termos-de-uso/" target="_blank">termos</a>
                                        </label>
                                        <!-- <small class="error w-100" v-if="errors && errors.has('termos')">{{ errors.first('termos') }}</small> -->
                                    </div>
                                   <div class="col-md-12 text-center">
                                        <a href="javascript:void(0);" @click="handleLogin()">Retornar para o login</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div v-if="estagio == 'fim'">
                <transition name="fade">
                        <div class="activation text-center">
                            <h2 class="title-principal">A conta foi criada com sucesso!</h2>
                            <h3>Em breve você receberá um e-mail para ativação da conta.</h3>
                            <button type="button" class="activation-button" @click="handleLogin()">Ok</button>
                        </div>
                </transition>
            </div>
    </div>
</template>

<script>

import { apiORDSapp } from '../shared/api-functions'
import apiLogin from '../api/api-login.js'
import VueRecaptcha from 'vue-recaptcha';

export default {
    props: {
        params: {
            app: String,
            plano: String,
        }
    },

    data() {
        return {
            registro: { nome: null, nomeempresa: null, senha: null, telefone: null, email: null, pessoa: null, cnpjcpf: null, tpempresa: null },
            errmessages: null,  //armazena as mensagens de validacao do servidor para mostrar em tela
            estagio: '',
            app: '',
            registrando: false,
            plano: '',

            metadata: { registro: {
                nome: { label: 'Nome', fieldname: 'nome' },
                nomeempresa: { label: 'Nome da Empresa', fieldname: 'nomeempresa' },
                email: { label: 'Email Para Login', fieldname: 'email' },
                senha: { label: 'Senha', fieldname: 'senha' },
                cnpj: { label: 'Cnpj', fieldname: 'cnpj' },
                cpf: { label: 'CPF', fieldname: 'cpf' },
                tpempresa: {
                    label: 'Tipo de Empresa', fieldname: 'tpempresa',
                    options: [
                        {id: 'S', text: 'Optante do Simples'},
                        {id: 'N', text: 'Normal'},
                        {id: 'E', text: 'Escritório Contabil'}
                        ]
                    },
                telefone: { label: 'Telefone', fieldname: 'telefone' },
                pessoa: {
                    label: 'Tipo de Pessoa', fieldname: 'pessoa',
                    options: [{id: 'J', text: 'Física'}, {id: 'F', text: 'Jurídica'}]
                    },
                obsconheceu: { label: 'Observações', fieldname: 'obsconheceu' },
                comoconheceu: {
                    label: 'Como Conheceu', fieldname: 'comoconheceu',
                    options: [
                        { id: '1', text: 'Google'},
                        { id: '2', text: 'Facebook'},
                        { id: '3', text: 'Indicação'},
                        { id: '4', text: 'Anuncio'},
                        { id: '5', text: 'Outros'},
                        ]
                    },
                }
            },

            email: '',
            senha: '',

            recaptcha: false,

        }
    },

    mixins: [apiLogin],

    computed: {
        selecionados: function () {
            return this.aplicativos.filter((obj) => {
               return obj.selected
            })
        },

        botaoRegistrar: function () {
            if (this.registrando)
                return 'Registrando...'
            else
                return 'Experimentar por 15 dias'
        },
    },

    methods: {
        verifyRecaptcha(response){
          this.recaptcha = true;
        },

        expiredRecaptcha(){
          this.recaptcha = false;
        },

        setGoogleTag(){
            const googleTagHead = document.createElement('script');
            googleTagHead.setAttribute('type', 'text/javascript');
            const googleScriptContent = document.createTextNode(`
                (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0], j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src= 'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f); })(window,document,'script','dataLayer','GTM-MP9QGL5');
            `);
            googleTagHead.appendChild(googleScriptContent);

            const firstChildScript = document.getElementsByTagName("script")[0];

            document.head.insertBefore(googleTagHead, firstChildScript);

            const googleTagBody = document.createElement('noscript');
            jQuery(googleTagBody).append(`
                <iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MP9QGL5" height="0" width="0" style="display:none;visibility:hidden"></iframe>
            `)


            const firstChildBody = document.body.firstElementChild

            document.body.insertBefore(googleTagBody, firstChildBody);
        },

        handleRegistrar () {

            if (!this.recaptcha){
              this.$erpToastWarning('A verificação "não sou um robô"(reCAPTCHA) deve ser realizada.');
              return;
            }

            //BOTAO REGISTRAR
            let self = this
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastWarning('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async apiPost () {
            //efetua o envio do registro para o servidor

            this.errmessages = null
            this.registrando = true

            var sendData = { registro: this.registro }
            sendData.registro.app = this.app
            sendData.registro.plano = this.plano

            this.$appLoading(true)
            const data = await apiORDSapp(this, 'assinatura/', 'post', sendData)
            this.$appLoading(false)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.registrando = false
              return
            } else if (data.status == 'exist') {
                this.errmessages = 'Já existe cadastro para este e-mail'
                this.registrando = false
                return
            }
            //sucesso, fecha formulario para efetuar logon
            this.errmessages = null
            this.registrando = false
            this.$scrollTo(0)
            this.email = this.registro.email
            this.senha = this.registro.senha
            this.apiLogin()
        },

        handleLogin () {
            this.$router.push('/login')
        },

        async apiPostLead () {
            //efetua o envio do registro para o servidor

            this.errmessages = null

            var sendData = { registro: this.registro }
            sendData.registro.app = this.app
            sendData.registro.plano = this.plano

            const data = await apiORDSapp(this, 'savelead/', 'post', sendData)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              return
            }
            this.errmessages = null
        },

},

    components: {
        VueRecaptcha
    },

    beforeCreate () {
    },

    mounted () {
      let email = this.$route.query.email;
      if (email){
          this.registro.email = email
          this.apiPostLead();
        }
        this.$nextTick(function () {

            this.$refs.email.focus()
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    },

    created () {
        this.estagio = 'registro'

        if (this.$route.name == 'registro') {
            this.$scrollTo(0)
            this.app = 'ERP'
            this.plano = '1-2022'
        } else
        if (this.$route.name == 'registropedidos') {
            this.app = 'FV'
            this.plano = 'C'
        } else
        if (this.$route.name == 'registronfe') {
            this.app = 'NFE'
            this.plano = 'C'
        } else
        if (this.$route.name == 'registroloja') {
            this.app = 'LOJA'
            this.plano = 'C'
        }

        this.setGoogleTag();

        this.app = this.app.toUpperCase()

    }

}

</script>

<style>

.shared-header {
    display: block;
    padding: 15px 0;
    margin-top: 15px;
}

.shared-header .valign {
    line-height: 30px;
    vertical-align: middle;
}

.registro {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fff;
  /* display: table; */
  display: block;
  transition: opacity .3s ease;
  overflow: auto;
}

.activation {
    margin-top: 64px;
}

.activation h3 {
    margin-bottom: 32px;
    font-size: 30.4px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.58;
    letter-spacing: -.5px;
    color: #222;
    margin-top: 64px;
}

.activation-button {
    border: 2px solid #267da5!important;
    /* border-radius: 3px!important; */
    border-radius: 0.70rem;
    margin-top: 50px;
    cursor: pointer;
    width: 200px!important;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}

.title-principal {
    color: #222;
    font-size: 36px;
    font-weight: 800;
    letter-spacing: -1.13px;
    line-height: 44px;
    margin: 25px 0 0;
}

.box-registro {
    margin: 10px 0 100px;
    display: flex;
    width: 472px;

    flex-direction: column;
    align-items: center;
    /* border: 1px solid #E0E0E0; */
    border-radius: 15px;
    padding: 15px;
    letter-spacing: -0.15px;
    line-height: 24px;
    transition: all .2s;
    box-shadow: 0 15px 45px 0 rgba(82,95,127,.15);
}

.login-button {
    border: 2px solid #267da5!important;
    border-radius: 0.70rem;
    cursor: pointer;
    height: 45px!important;
    background-color: #267da5!important;
    color: #fff!important;
    font-size: 15px!important;
}

</style>



// WEBPACK FOOTER //
// src/forms/app-registro-form.vue